import React, { useRef, useState, useEffect } from "react";
import { Navbar, Button } from "flowbite-react";
import { HiArrowLeft } from "react-icons/hi2";
import phbDecalSvg from "../../../img/phv-decal.svg";
import { FaCamera } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { handleLoadPhvDecalPic, handlePhvUpload } from "./handler" ;
import { MdCheckCircle } from "react-icons/md";
import { BsThreeDots } from "react-icons/bs";

const PhvDecalComponent = (props) => {
  const cssForImageCard = {
    success : {
      imageDiv: 'mt-2 mb-10 custom-card-success border rounded-md items-center shadow-none p-10',
    },
    standard : {
      imageDiv: 'mt-2 mb-10 custom-card border rounded-md items-center shadow-none p-10',
    }
  }

  const phvDecalRef = useRef(null);
  const selectedProfileType = JSON.parse(sessionStorage.getItem("selectedProfileType"));

  const navigate = useNavigate();
  let [phvDecalPic, setPhvDecalPic] = useState();
  let [userUploadedPhvDecalPic, setUserUploadedPhvDecalPic] = useState(false)
  let [phvDecalPicLoading, setPhvDecalPicLoading] = useState(false)
  let [validationOnSubmit, setValidationOnSubmit] = useState(false)
  let [showButton, setShowButton] = useState(false)
  let [validation, setValidation] = useState({
    show: false,
    message: "",
    class: "",
  });

  useEffect(() => {
    handleLoadPhvDecalPic(props.itemIndex, props.memberRequirement.requiredDocuments,setPhvDecalPic,setUserUploadedPhvDecalPic,phbDecalSvg)
  },[])

    return (
      <>
        <Navbar
          fluid={true}
          rounded={true}
          className="shadow mb-3"
          style={{ position: "fixed", width: "100%", top: "0" }}
        >
          <Navbar.Brand
            onClick={() => {
              props.setOpenUploadDocument({
                openDocument: false,
                documentType: "",
              });
            }}
          >
            <HiArrowLeft className="h-10 w-5 ml-2" />
          </Navbar.Brand>
        </Navbar>
        <div className='p-6  max-w-md m-auto' style={{paddingTop:'80px'}}>
          <h5 className="text-2xl mb-2 font-bold tracking-tight text-gray-900 dark:text-white">
          PHV Decal
          </h5>
          {
            validationOnSubmit && 
            <div className="error-msg">
              <span>Need to PHV Decal before submitting for verification</span>
            </div>
          }
          { 
          validation.show && 
          <div className="error-msg">
            <span>{validation.message}</span>
          </div>
          }
        {
          userUploadedPhvDecalPic && 
          <div class="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white" style={{paddingRight: '10px'}}>
            <MdCheckCircle style = {{ color: '#15BE44' }}/>
          </div>
        }
          <label className='font-bold tracking-tight text-gray-900'>Image</label>
          <div className={ userUploadedPhvDecalPic ?  cssForImageCard.success.imageDiv : cssForImageCard.standard.imageDiv }>
          {
            validation.show && (
              <div className={validation.class}>
                 <span>{validation.message}</span>
              </div>
            )
          }
              <img src={phvDecalPic}
                  className="w-auto m-auto"
                  alt="Ryde" 
              />
              <p className='text-xs text-gray-400 tracking-tight mt-2'><i>.We accept any of the following: <br/>
                  1. Photo of your PHV decal (with legible serial number) <br/>
                  2. Screenshot from LTA ONE MOTORING website<br/>
                  3. Decal Slip<br/><br/><br/>
                  . License plate number must match that of your commercial insurance and vehicle log.<br/> 
                  </i></p>
              <Button  pill={true} className='mt-5 m-auto w-sm pr-4' onClick={(e)=>{
                e.preventDefault();
                phvDecalRef.current.click();
            }}>
                 {
                phvDecalPicLoading ? <BsThreeDots className="h-5 w-10" /> : <FaCamera className="h-5 w-10" />
              }
                  <label // for="file-upload"
                  className="relative cursor-pointer rounded-md font-medium">
                      <span>{phvDecalPicLoading ? 'Saving' : userUploadedPhvDecalPic ? 'Replace' : 'Upload' }</span>
                  </label>
              </Button>
              <input 
                  id="file-upload" 
                  name="file-upload"
                  type="file"
                  ref={phvDecalRef}
                  style={{display: 'none', width:'0px'}}
                  onChange={async (event) => {
                    await handlePhvUpload(event, setValidation, setPhvDecalPicLoading, setUserUploadedPhvDecalPic,
                      "phvDecal", "phvDecal", selectedProfileType.profileId, setPhvDecalPic, navigate, props.memberRequirement, props.setMemberRequirement,props.itemIndex);
                      setValidationOnSubmit(false)
                  }}
              />
          </div>
  
          <Button className='bg-primary w-full mt-5' pill={true} disabled={false} 
              onClick={()=>{
                if(userUploadedPhvDecalPic ) {
                  props.setOpenUploadDocument({
                    openDocument: false,
                    documentType: "",
                  });
                } else {
                  setValidationOnSubmit(true)
                  window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
                }
              }}
          >
              Save
          </Button>
        </div>
      </>
    )
}

export default PhvDecalComponent;